import { IEBPExpenseType, IProduct, ITest } from "./TestInterface";
import { IWell } from "./WellInterface";

export class IDispatchBase {
    public id: string = '';
    public sourceWellId: string = '';
    public sourceWell: IWell;
    public destinationWellId: string = '';
    public destinationWell: IWell;
    public submittedWellTest: ITest;
    public submittedWellTestId: string | null = '';
    public submittedWell: IWell;
    public submittedWellId : string | null;
    public receivedWellTest: ITest;
    public receivedWellTestId: string = '';
    public type: string;
}

export class IDispatchList extends IDispatchBase {
    public dispatchStatus: string;
    public createBy: string;
    public createDate: string;
    public statusChangeBy: string;
    public statusChangeDate: string;
    public requestedArrival: string;
    public estimatedArrival: string;
}

export class IDispatchConfirm {
    public id: string;
    public requestestArrival: string;
    public estimatedArrival: string;
    public submittedWellTest: ITest;
    public type: string;
    public trucks: IDispatchTruck[];
}

export class IDispatch extends IDispatchBase {
    public items: IDispatchItem[] = [];
    public comment: string;
    public requestedArrival: string = undefined as unknown as string;
    public estimatedArrival: string;
}

export class IDispatchUpdate {
    public id: string;
    public trucks: IDispatchTruck[] = [];
    public comment: string;
    public requestedArrival: string;
    public estimatedArrival: string;
}

export class IDispatchTruck {
    public id: string = '';
    public ordinal: number;
    public status: string = '';
    public estimatedArrival: string = '';
    public returnedWellTestId: string = '';
    public returnedWellCloseReviewId: string = '';
    public items: IDispatchItem[] = [];
}

export class IDispatchItem {
    public id: string = '';
    public productId: string;
    public product: IProduct;
    public expenseId: string;
    public expense: IEBPExpenseType;
    public quantity: any = '';
    public price: number;
}

export class IDispatchItemRow extends IDispatchItem {
    public closing: string = '';
}

export class IDispatchStatus
{
    public id: string = '';
    public status: string = '';
    public comment: string = '';
    public requestedArrival: string = '';
    public estimatedArrival: string = '';
    public destinationWellId?: string | null = '';
}

export class IDispatchHistory extends IDispatchStatus {
    public dispatchHeader: IDispatchBase;
    public trucks: IDispatchTruck[] = [];
    public statusChangeBy: string;
    public statusChangeDate: string;
}

export class IDispatchComment {
    public id: string = '';
    public comment: string = '';
    public commentBy: string = '';
    public commentDate: string = '';
}
export class IDispatchDetail
{
    public id: string = '';
    public dispatchHistory: IDispatchHistory[] = [];
    public comments: IDispatchComment[] = [];
}


// WEBPACK FOOTER //
// ./src/Interfaces/DispatchInterface.ts